(function () {
  // Public creator profile (/pages/profile?u=<username>): a small landing page
  // for an artist. Name and one line, Follow / Contact, tracks made in Wet
  // Studio, shared waves, and "Work with me" (what they take on, booking
  // email, links). Followers / following open in a panel on the same page.
  // Design: the site's green on deep, square corners, Anton headings.

  function escapeHtml(value) {
    if (value === null || value === undefined) return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function isSafeImageUrl(url) {
    return typeof url === 'string' && /^https:\/\//i.test(url);
  }

  function isSafeLinkUrl(url) {
    if (typeof url !== 'string' || !url) return false;
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch (e) {
      return false;
    }
  }

  function getUsernameFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return (params.get('u') || '').trim();
  }

  function formatDuration(secs) {
    if (!secs) return '';
    var s = Math.round(secs);
    return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
  }

  function ago(iso) {
    var t = new Date(iso).getTime(); if (!t) return '';
    var d = (Date.now() - t) / 86400000;
    if (d < 1) return 'today'; if (d < 2) return 'yesterday'; if (d < 7) return Math.floor(d) + ' days ago';
    if (d < 30) return Math.floor(d / 7) + (d < 14 ? ' week ago' : ' weeks ago');
    return new Date(t).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  }

  function displayName(p) { return p.display_name || p.username; }
  function initials(p) {   // "Reigning Wet" -> RW, "mistyb" -> MI
    var words = displayName(p).split(/[\s._-]+/).filter(function (w) { return /[A-Za-z0-9]/.test(w); });
    var s = words.length > 1 ? words[0].charAt(0) + words[1].charAt(0) : (words[0] || '').replace(/[^A-Za-z0-9]/g, '').slice(0, 2);
    return (s || '?').toUpperCase();
  }
  function profileUrl(p) { return window.ReigningWet.getProfileUrl ? window.ReigningWet.getProfileUrl(p.username) : '/pages/profile?u=' + encodeURIComponent(p.username); }
  function avatar(p, cls) {
    return isSafeImageUrl(p.avatar_url)
      ? '<span class="' + cls + '" style="background-image:url(' + escapeHtml(p.avatar_url) + ')"></span>'
      : '<span class="' + cls + '">' + escapeHtml(initials(p)) + '</span>';
  }

  var LINK_LABELS = [['instagram', 'Instagram'], ['youtube', 'YouTube'], ['soundcloud', 'SoundCloud'], ['beatstars', 'BeatStars'], ['tiktok', 'TikTok']];
  var ICON_PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
  var ICON_PAUSE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5h4v14H7zM13 5h4v14h-4z"/></svg>';

  // ---------------------------------------------------------------- data
  var sb, container, P = null, S = { tab: 'tracks', tracks: [], waves: [], followers: 0, following: 0, iFollow: false, playing: null, busy: false, likes: { counts: {}, mine: {} }, xp: null, badges: [] };

  function me() { var p = window.ReigningWet.getProfile && window.ReigningWet.getProfile(); return p && p.id ? p : null; }

  function fetchProfile(username) {
    return sb.from('profiles').select('*').eq('username', username).maybeSingle().then(function (r) {
      if (r.error) throw r.error;
      return r.data && !r.data.is_banned ? r.data : null;
    });
  }
  function fetchTracks(id) {
    return sb.from('wetstudio_public_tracks').select('id, name, bpm, key_label, duration, preview_path, published_at')
      .eq('profile_id', id).order('published_at', { ascending: false }).limit(50)
      .then(function (r) {
        if (r.error) throw r.error;
        return (r.data || []).map(function (t) { t.url = sb.storage.from('wetstudio-public').getPublicUrl(t.preview_path).data.publicUrl; return t; });
      });
  }
  function fetchWaves(id) {
    return sb.from('submissions').select('id, project_title, project_url, category, location_display, created_at')
      .eq('profile_id', id).eq('is_published', true).order('created_at', { ascending: false })
      .then(function (r) { if (r.error) throw r.error; return r.data || []; });
  }
  function countFollows(col, id) {
    return sb.from('follows').select('follower_id', { count: 'exact', head: true }).eq(col, id)
      .then(function (r) { return r.error ? 0 : r.count || 0; });
  }
  function fetchIFollow(id) {
    var m = me(); if (!m || m.id === id) return Promise.resolve(false);
    return sb.from('follows').select('follower_id').eq('follower_id', m.id).eq('following_id', id).maybeSingle()
      .then(function (r) { return !r.error && !!r.data; });
  }
  // people who follow `id` (dir "followers") or whom `id` follows ("following")
  function fetchPeople(id, dir) {
    var col = dir === 'followers' ? 'following_id' : 'follower_id', other = dir === 'followers' ? 'follower_id' : 'following_id';
    return sb.from('follows').select(other + ', created_at').eq(col, id).order('created_at', { ascending: false }).limit(300)
      .then(function (r) {
        if (r.error) throw r.error;
        var ids = (r.data || []).map(function (x) { return x[other]; });
        if (!ids.length) return [];
        return sb.from('profiles').select('id, username, display_name, creative_role, avatar_url, is_banned').in('id', ids).then(function (r2) {
          if (r2.error) throw r2.error;
          var byId = {}; (r2.data || []).forEach(function (p) { byId[p.id] = p; });
          return ids.map(function (i) { return byId[i]; }).filter(function (p) { return p && !p.is_banned; });
        });
      });
  }
  function myFollowSet(ids) {
    var m = me(); if (!m || !ids.length) return Promise.resolve({});
    return sb.from('follows').select('following_id').eq('follower_id', m.id).in('following_id', ids).then(function (r) {
      var set = {}; (r.data || []).forEach(function (x) { set[x.following_id] = true; }); return set;
    });
  }
  function setFollow(targetId, on) {
    var m = me(); if (!m) return Promise.reject(new Error('signed out'));
    return on
      ? sb.from('follows').insert({ follower_id: m.id, following_id: targetId }).then(function (r) { if (r.error && r.error.code !== '23505') throw r.error; })
      : sb.from('follows').delete().eq('follower_id', m.id).eq('following_id', targetId).then(function (r) { if (r.error) throw r.error; });
  }
  // run fn signed in: opens sign-in first if needed
  function signedIn(fn) {
    if (me()) return fn();
    if (window.ReigningWet.requireAuth) window.ReigningWet.requireAuth(function () { setTimeout(fn, 300); });
  }

  // ---------------------------------------------------------------- render
  function render() {
    var p = P, mine = me() && me().id === p.id;
    var meta = ['@' + p.username];
    if (p.creative_role) meta.push(p.creative_role);
    if (p.location_display) meta.push(p.location_display);
    var openFor = Array.isArray(p.open_for) ? p.open_for : [];
    var links = [];
    if (isSafeLinkUrl(p.website_url)) links.push(['Website', p.website_url]);
    var L = p.links && typeof p.links === 'object' ? p.links : {};
    LINK_LABELS.forEach(function (x) { if (isSafeLinkUrl(L[x[0]])) links.push([x[1], L[x[0]]]); });
    var hasWork = openFor.length || p.booking_email || links.length;

    var h = [];
    h.push('<main class="rp">');
    h.push('<header class="rp-id">' + avatar(p, 'rp-avatar') + '<div class="rp-idtext"><h1 class="rp-name">' + escapeHtml(displayName(p)) +
      (p.is_founder ? ' <span class="rp-founder" title="Founder">★</span>' : '') + '</h1><div class="rp-meta">' + meta.map(escapeHtml).join(' · ') + '</div>' + levelHtml() + '</div></header>');

    h.push('<div class="rp-actions">');
    if (mine) h.push('<button type="button" class="rp-btn" data-rp="edit">Edit profile</button>');
    else h.push('<button type="button" class="rp-btn' + (S.iFollow ? ' is-ghost' : '') + '" data-rp="follow" aria-pressed="' + S.iFollow + '">' + (S.iFollow ? 'Following' : 'Follow') + '</button>');
    if (hasWork && !mine) h.push('<a class="rp-btn is-ghost" href="#rp-work">Contact</a>');
    h.push('<span class="rp-sp"></span><div class="rp-stats">' +
      '<span><b>' + S.tracks.length + '</b> ' + (S.tracks.length === 1 ? 'track' : 'tracks') + '</span>' +
      '<button type="button" data-rp="list:followers"><b>' + S.followers + '</b> ' + (S.followers === 1 ? 'follower' : 'followers') + '</button>' +
      '<button type="button" data-rp="list:following"><b>' + S.following + '</b> following</button></div>');
    h.push('</div>');

    if (p.bio) h.push('<p class="rp-bio">' + escapeHtml(p.bio) + '</p>');

    h.push('<nav class="rp-tabs" role="tablist">' + [['tracks', 'Tracks'], ['waves', 'Waves']].map(function (t) {
      return '<button type="button" role="tab" aria-selected="' + (S.tab === t[0]) + '" class="' + (S.tab === t[0] ? 'is-on' : '') + '" data-rp="tab:' + t[0] + '">' + t[1] + '</button>';
    }).join('') + '</nav>');

    if (S.tab === 'tracks') {
      if (!S.tracks.length) h.push('<p class="rp-empty">' + (mine ? 'Post a song from Wet Studio (Song menu → Private → Post to my profile) and it plays here.' : 'No tracks yet.') + '</p>');
      h.push('<div class="rp-list">' + S.tracks.map(function (t, i) {
        var on = S.playing === i, bits = [];
        if (t.bpm) bits.push(t.bpm + ' BPM'); if (t.key_label) bits.push(t.key_label); bits.push(ago(t.published_at));
        return '<div class="rp-track' + (on ? ' is-on' : '') + '"><div class="rp-trow">' +
          '<button type="button" class="rp-play" data-rp="play:' + i + '" aria-label="' + (on ? 'Pause ' : 'Play ') + escapeHtml(t.name || 'track') + '">' + (on ? ICON_PAUSE : ICON_PLAY) + '</button>' +
          '<div class="rp-ttext"><div class="rp-ttitle">' + escapeHtml(t.name || 'Untitled') + '</div><div class="rp-tmeta">' + escapeHtml(bits.join(' · ')) + '</div></div>' +
          likeBtn(t) + '<span class="rp-tlen">' + formatDuration(t.duration) + '</span></div>' +
          (on ? '<div class="rp-prog" data-rp="seek" role="slider" aria-label="Seek" aria-valuemin="0" aria-valuemax="100" tabindex="0"><i id="rp-prog-fill"></i></div>' : '') + '</div>';
      }).join('') + '</div>');
      if (S.tracks.length) h.push('<p class="rp-note">Made in Wet Studio. Previews play with a “Reigning Wet” voice tag.</p>');
    } else {
      if (!S.waves.length) h.push('<p class="rp-empty">No waves shared yet.</p>');
      h.push('<div class="rp-list">' + S.waves.map(function (w) {
        var tail = [w.category, w.location_display].filter(Boolean).map(escapeHtml).join(' · ');
        var inner = '<span class="rp-wtitle">' + escapeHtml(w.project_title) + '</span><span class="rp-tmeta">' + tail + (isSafeLinkUrl(w.project_url) ? ' →' : '') + '</span>';
        return isSafeLinkUrl(w.project_url)
          ? '<a class="rp-wave" href="' + escapeHtml(w.project_url) + '" target="_blank" rel="noopener noreferrer">' + inner + '</a>'
          : '<div class="rp-wave">' + inner + '</div>';
      }).join('') + '</div>');
    }

    if (hasWork || mine) {
      h.push('<section class="rp-work" id="rp-work"><h2 class="rp-h2">Work with me</h2>');
      if (!hasWork) h.push('<p class="rp-empty">Add what you’re open for, a booking email and your links in <button type="button" class="rp-inline" data-rp="edit">Edit profile</button>.</p>');
      if (openFor.length) h.push('<p class="rp-open">Open for ' + escapeHtml(joinNice(openFor).toLowerCase()) + '.</p>');
      h.push('<div class="rp-workrow">');
      if (p.booking_email) h.push('<a class="rp-btn" href="mailto:' + encodeURIComponent(p.booking_email).replace(/%40/g, '@') + '?subject=' + encodeURIComponent('Booking request via Reigning Wet') + '">Send a booking request</a><span class="rp-email">' + escapeHtml(p.booking_email) + '</span>');
      h.push('<span class="rp-sp"></span><div class="rp-links">' + links.map(function (l) { return '<a href="' + escapeHtml(l[1]) + '" target="_blank" rel="noopener noreferrer">' + l[0] + '</a>'; }).join('') + '</div></div></section>');
    }
    h.push('<footer class="rp-foot">REIGNING WET /// .WAVS LAST FOREVER</footer></main>');
    h.push('<dialog class="rp-dlg" id="rp-dlg" aria-labelledby="rp-dlg-title"></dialog>');
    container.innerHTML = h.join('');
  }
  function joinNice(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }

  // ---------------------------------------------------------------- followers / following panel
  var LIST = { dir: 'followers', people: [], mine: {} };
  function openList(dir) {
    LIST.dir = dir;
    var dlg = document.getElementById('rp-dlg'); if (!dlg) return;
    renderList(true);
    if (dlg.showModal && !dlg.open) dlg.showModal();
    fetchPeople(P.id, dir).then(function (people) {
      LIST.people = people;
      return myFollowSet(people.map(function (x) { return x.id; }));
    }).then(function (set) { LIST.mine = set; renderList(false); }, function () { LIST.people = []; renderList(false, true); });
  }
  function renderList(loading, failed) {
    var dlg = document.getElementById('rp-dlg'), m = me();
    var h = ['<div class="rp-dhead"><b id="rp-dlg-title">' + escapeHtml(displayName(P)) + '</b><button type="button" class="rp-x" data-rp="close" aria-label="Close">×</button></div>'];
    h.push('<nav class="rp-tabs" role="tablist">' + [['followers', S.followers + ' Followers'], ['following', S.following + ' Following']].map(function (t) {
      return '<button type="button" role="tab" aria-selected="' + (LIST.dir === t[0]) + '" class="' + (LIST.dir === t[0] ? 'is-on' : '') + '" data-rp="list:' + t[0] + '">' + t[1] + '</button>';
    }).join('') + '</nav><div class="rp-people">');
    if (loading) h.push('<p class="rp-empty">Loading…</p>');
    else if (failed) h.push('<p class="rp-empty">Couldn’t load this list right now.</p>');
    else if (!LIST.people.length) h.push('<p class="rp-empty">' + (LIST.dir === 'followers' ? 'No followers yet.' : 'Not following anyone yet.') + '</p>');
    else LIST.people.forEach(function (x) {
      var self = m && m.id === x.id, on = !!LIST.mine[x.id];
      h.push('<div class="rp-person"><a href="' + escapeHtml(profileUrl(x)) + '" class="rp-plink">' + avatar(x, 'rp-pav') +
        '<span class="rp-ptext"><span>' + escapeHtml(displayName(x)) + '</span><small>' + escapeHtml(x.creative_role || '@' + x.username) + '</small></span></a>' +
        (self ? '' : '<button type="button" class="rp-btn rp-sm' + (on ? ' is-ghost' : '') + '" data-rp="pfollow:' + escapeHtml(x.id) + '">' + (on ? 'Following' : 'Follow') + '</button>') + '</div>');
    });
    h.push('</div>');
    dlg.innerHTML = h.join('');
  }

  // ---------------------------------------------------------------- playback
  var audio = null;
  function play(i) {
    if (!audio) {
      audio = new Audio(); audio.preload = 'none';
      audio.addEventListener('ended', function () { S.playing = null; render(); });
      audio.addEventListener('timeupdate', function () {
        var f = document.getElementById('rp-prog-fill'); if (f && audio.duration) f.style.width = (audio.currentTime / audio.duration * 100) + '%';
      });
    }
    if (S.playing === i) { audio.pause(); S.playing = null; render(); return; }
    var t = S.tracks[i]; if (!t || !isSafeLinkUrl(t.url)) return;
    audio.src = t.url; audio.play().catch(function () {});
    S.playing = i; render();
  }

  // level + badges (views profile_xp / profile_badges, supabase-migrations/2026-10-19_xp-wet-world.sql)
  function levelHtml() {
    if (S.xp == null || !window.ReigningWet.getLevelInfo) return '';
    var L = window.ReigningWet.getLevelInfo(S.xp), order = window.ReigningWet.BADGE_ORDER || [];
    var badges = S.badges.slice().sort(function (a, b) { return (order.indexOf(a.slug) + 99) % 99 - (order.indexOf(b.slug) + 99) % 99; });
    return '<div class="rp-level"><span class="rp-lvl">' + escapeHtml(L.name) + '</span><span class="rp-xpbar"><i style="width:' + Math.round(L.progress * 100) + '%"></i></span><span class="rp-xp">' + S.xp + ' XP</span></div>' +
      (badges.length ? '<div class="rp-badges">' + badges.slice(0, 6).map(function (b) { return '<span class="rp-badge" title="' + escapeHtml(b.description || '') + '">' + escapeHtml(b.name) + '</span>'; }).join('') + (badges.length > 6 ? '<span class="rp-badge is-more">+' + (badges.length - 6) + '</span>' : '') + '</div>' : '');
  }
  function loadLevel(id) {
    Promise.all([
      sb.from('profile_xp').select('xp').eq('profile_id', id).maybeSingle(),
      sb.from('profile_badges').select('slug, name, description').eq('profile_id', id)
    ]).then(function (r) {
      if (r[0].error) return;   // views not there yet: no level shown
      S.xp = (r[0].data && r[0].data.xp) || 0; S.badges = (!r[1].error && r[1].data) || []; render();
    }, function () {});
  }

  // likes (assets/rw-social.js); the hearts stay hidden until the likes table exists
  function social() { return window.ReigningWet.social; }
  function likeBtn(t) {
    var so = social(); if (!so || !so.likes.ready) return '';
    var on = !!S.likes.mine[t.id], n = S.likes.counts[t.id] || 0;
    return '<button type="button" class="rp-like' + (on ? ' is-on' : '') + '" data-rp="like:' + escapeHtml(t.id) + '" aria-pressed="' + on + '" aria-label="' + (on ? 'Unlike ' : 'Like ') + escapeHtml(t.name || 'track') + '">' + so.likes.heart(on) + (n ? '<span>' + n + '</span>' : '') + '</button>';
  }
  function loadLikes() {
    var so = social(); if (!so || !so.likes.ready || !S.tracks.length) return;
    so.likes.load(S.tracks.map(function (t) { return t.id; })).then(function (r) { S.likes = r; render(); });
  }
  function toggleLike(id) {
    var so = social(); if (!so || !so.likes.ready) return;
    var was = !!S.likes.mine[id], signed = !!me();
    function apply(on) { if (on) S.likes.mine[id] = true; else delete S.likes.mine[id]; S.likes.counts[id] = Math.max(0, (S.likes.counts[id] || 0) + (on ? 1 : -1)); render(); }
    if (signed) apply(!was);   // show it straight away; undo if the server says no
    so.likes.toggle(id, signed ? was : undefined).then(function (liked) { if (liked !== !!S.likes.mine[id]) apply(liked); }, function () { if (signed && !!S.likes.mine[id] !== was) apply(was); });
  }
  document.addEventListener('reigningwet:likes-ready', loadLikes);
  document.addEventListener('reigningwet:auth-change', loadLikes);

  // ---------------------------------------------------------------- events
  function onClick(e) {
    var b = e.target.closest('[data-rp]'); if (!b) return;
    var v = b.getAttribute('data-rp'), arg = v.indexOf(':') > 0 ? v.slice(v.indexOf(':') + 1) : '', c = arg ? v.slice(0, v.indexOf(':')) : v;
    if (c === 'tab') { S.tab = arg; render(); }
    else if (c === 'play') play(+arg);
    else if (c === 'like') toggleLike(arg);
    else if (c === 'seek') { if (audio && audio.duration) { var r = b.getBoundingClientRect(); audio.currentTime = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * audio.duration; } }
    else if (c === 'edit') { if (window.ReigningWet.openAccount) window.ReigningWet.openAccount('profile-edit'); }
    else if (c === 'list') openList(arg);
    else if (c === 'close') { var d = document.getElementById('rp-dlg'); if (d && d.close) d.close(); }
    else if (c === 'follow') signedIn(function () {
      if (S.busy || !me() || me().id === P.id) return;
      var next = !S.iFollow; S.busy = true;
      S.iFollow = next; S.followers += next ? 1 : -1; render();   // instant, then confirm
      setFollow(P.id, next).then(function () { S.busy = false; }, function () { S.busy = false; S.iFollow = !next; S.followers += next ? -1 : 1; render(); });
    });
    else if (c === 'pfollow') signedIn(function () {
      var on = !LIST.mine[arg]; LIST.mine[arg] = on; renderList(false);
      setFollow(arg, on).then(function () {
        if (me() && P.id === me().id) { S.following += on ? 1 : -1; render(); renderList(false); }
      }, function () { LIST.mine[arg] = !on; renderList(false); });
    });
  }

  function renderNotFound() {
    container.innerHTML = '<main class="rp rp-center"><p class="rp-eyebrow">profile</p><h1 class="rp-name">Not found</h1><p class="rp-meta">There’s no creator with that name.</p></main>';
  }
  function renderError() {
    container.innerHTML = '<main class="rp rp-center"><p class="rp-eyebrow">profile</p><h1 class="rp-name">Couldn’t load</h1><p class="rp-meta">Try again in a moment.</p></main>';
  }

  function load(username) {
    fetchProfile(username).then(function (profile) {
      if (!profile) return renderNotFound();
      P = profile;
      document.title = displayName(P) + ' – Reigning Wet';
      return Promise.all([
        fetchTracks(P.id).catch(function () { return []; }),
        fetchWaves(P.id).catch(function () { return []; }),
        countFollows('following_id', P.id),
        countFollows('follower_id', P.id),
        fetchIFollow(P.id).catch(function () { return false; })
      ]).then(function (r) {
        S.tracks = r[0]; S.waves = r[1]; S.followers = r[2]; S.following = r[3]; S.iFollow = r[4];
        if (!S.tracks.length && S.waves.length) S.tab = 'waves';
        render(); loadLikes(); loadLevel(P.id);
      });
    }).catch(function (error) {
      if (window.console) console.error('[ReigningWet] Failed to load public profile:', error);
      renderError();
    });
  }

  function boot() {
    container = document.getElementById('rw-profile-page');
    if (!container) return;
    var username = getUsernameFromUrl();
    container.addEventListener('click', onClick);
    if (!username) { renderNotFound(); return; }
    function withSupabase() {
      sb = window.ReigningWet.supabase;
      load(username);
      // signing in or out changes the Follow / Edit profile button
      if (window.ReigningWet.onAuthChange) window.ReigningWet.onAuthChange(function () {
        if (!P) return;
        fetchIFollow(P.id).then(function (v) { S.iFollow = v; render(); }, function () { render(); });
      });
    }
    if (window.ReigningWet && window.ReigningWet.supabase) withSupabase();
    else {
      document.addEventListener('reigningwet:supabase-ready', withSupabase, { once: true });
      document.addEventListener('reigningwet:supabase-error', renderError, { once: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();